import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_3 = { class: "card mb-5 mb-xl-8" }
const _hoisted_4 = { class: "card-body pt-15" }
const _hoisted_5 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_6 = { class: "symbol symbol-50px symbol-circle mb-7" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
}
const _hoisted_9 = { class: "fs-5 fw-bold text-muted mb-2" }
const _hoisted_10 = { class: "d-flex flex-stack fs-4 py-3" }
const _hoisted_11 = {
  class: "fw-bolder rotate collapsible",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Details ")
const _hoisted_13 = { class: "ms-2 rotate-180" }
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_16 = {
  id: "kt_customer_view_details",
  class: "collapse show"
}
const _hoisted_17 = { class: "py-5 fs-6" }
const _hoisted_18 = { class: "fw-bolder mt-5" }
const _hoisted_19 = {
  key: 0,
  class: "text-gray-600"
}
const _hoisted_20 = {
  href: "#",
  class: "text-gray-600 text-hover-primary"
}
const _hoisted_21 = {
  key: 1,
  class: "text-gray-600"
}
const _hoisted_22 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_23 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_24 = { class: "card mb-5 mb-xl-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Login")
  ])
], -1)
const _hoisted_26 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_27 = { class: "card-body border-top p-9" }
const _hoisted_28 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Email Address", -1)
const _hoisted_30 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-6 mb-4 mb-lg-0" }
const _hoisted_33 = { class: "fv-row mb-0" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Enter New Email Address", -1)
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "col-lg-6" }
const _hoisted_38 = { class: "fv-row mb-0" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmemailpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirm Password", -1)
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = {
  id: "kt_signin_submit",
  type: "submit",
  ref: "updateEmailButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Update Email ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Password must be at least 8 character and contain symbols ", -1)
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4" }
const _hoisted_54 = { class: "fv-row mb-0" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  for: "currentpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Current Password", -1)
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "col-lg-4" }
const _hoisted_59 = { class: "fv-row mb-0" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "New Password", -1)
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "col-lg-4" }
const _hoisted_64 = { class: "fv-row mb-0" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirm New Password", -1)
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "d-flex" }
const _hoisted_69 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Update Password ", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { class: "card mb-5 mb-xl-10" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_deactivate",
  "aria-expanded": "true",
  "aria-controls": "kt_account_deactivate"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Deactivate Account")
  ])
], -1)
const _hoisted_75 = {
  id: "kt_account_deactivate",
  class: "collapse hide"
}
const _hoisted_76 = { class: "card-body border-top p-9" }
const _hoisted_77 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_78 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> You Are Deactivating Your Account </h4><div class=\"fs-6 text-gray-600\"> For extra security, this requires you to confirm your email or phone number when you reset yousignr password. <br><a class=\"fw-bolder\" href=\"#\">Learn more</a></div></div></div>", 1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-solid fv-row" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "deactivate",
    class: "form-check-input",
    type: "checkbox",
    value: "",
    id: "deactivate"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label fw-bold ps-2 fs-6",
    for: "deactivate"
  }, "Confirm Account Deactivation")
], -1)
const _hoisted_81 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_82 = {
  id: "kt_account_deactivate_account_submit",
  ref: "submitButton5",
  type: "submit",
  class: "btn btn-danger fw-bold"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Deactivate Account ", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaymentMethods = _resolveComponent("PaymentMethods")!
  const _component_Invoices = _resolveComponent("Invoices")!
  const _component_Users = _resolveComponent("Users")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.userData.adminpic,
                alt: "image"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.userData.adminfullname), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.userData.admintitle), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr072.svg" })
                ])
              ])
            ])
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetailFields, (fieldName, key) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(fieldName), 1),
                  (key == 'username')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.userData[key]), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.userData[key]), 1))
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", {
                  id: "kt_signin_email",
                  class: _normalizeClass({ 'd-none': _ctx.emailFormDisplay })
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.userName), 1)
                ], 2),
                _createElementVNode("div", {
                  id: "kt_signin_email_edit",
                  class: _normalizeClass([{ 'd-none': !_ctx.emailFormDisplay }, "flex-row-fluid"])
                }, [
                  _createVNode(_component_Form, {
                    id: "kt_signin_change_email",
                    class: "form",
                    novalidate: "novalidate",
                    onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateEmail())),
                    "validation-schema": _ctx.changeEmail
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createVNode(_component_Field, {
                              type: "email",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              id: "username",
                              placeholder: "Email Address",
                              name: "username",
                              modelValue: _ctx.userName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_ErrorMessage, { name: "username" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "confirmemailpassword",
                              id: "confirmemailpassword",
                              modelValue: _ctx.confirmemailpassword,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmemailpassword) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_ErrorMessage, { name: "confirmemailpassword" })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("button", _hoisted_43, _hoisted_46, 512),
                        _createElementVNode("button", {
                          id: "kt_signin_cancel",
                          type: "button",
                          class: "btn btn-color-gray-400 btn-active-light-primary px-6",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelUpdateEmail()))
                        }, " Cancel ")
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ], 2),
                _createElementVNode("div", {
                  id: "kt_signin_email_button",
                  class: _normalizeClass([{ 'd-none': _ctx.emailFormDisplay }, "ms-auto"])
                }, [
                  _createElementVNode("button", {
                    class: "btn btn-light fw-boldest px-6",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
                  }, " Change Email ")
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", {
                  id: "kt_signin_password",
                  class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
                }, _hoisted_50, 2),
                _createElementVNode("div", {
                  id: "kt_signin_password_edit",
                  class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
                }, [
                  _hoisted_51,
                  _createVNode(_component_Form, {
                    id: "kt_signin_change_password",
                    class: "form",
                    novalidate: "novalidate",
                    onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updatePassword())),
                    "validation-schema": _ctx.changePassword
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _hoisted_55,
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "currentpassword",
                              id: "currentpassword",
                              modelValue: _ctx.currentpassword,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentpassword) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createVNode(_component_ErrorMessage, { name: "currentpassword" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "newpassword",
                              id: "newpassword",
                              modelValue: _ctx.newPassword,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newPassword) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_ErrorMessage, { name: "newpassword" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createVNode(_component_Field, {
                              type: "password",
                              class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                              name: "confirmpassword",
                              id: "confirmpassword"
                            }),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("button", _hoisted_69, _hoisted_72, 512),
                        _createElementVNode("button", {
                          id: "kt_password_cancel",
                          type: "button",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelUpdatePassword())),
                          class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                        }, " Cancel ")
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ], 2),
                _createElementVNode("div", {
                  id: "kt_signin_password_button",
                  class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                    class: "btn btn-light fw-boldest"
                  }, " Reset Password ")
                ], 2)
              ])
            ])
          ])
        ]),
        _createVNode(_component_PaymentMethods, {
          "card-classes": "mb-6 col-12 mb-xl-9",
          paymentProfiles: _ctx.paymentProfiles
        }, null, 8, ["paymentProfiles"]),
        _createVNode(_component_Invoices, { "card-classes": "mb-6 mb-xl-9" }),
        _createVNode(_component_Users),
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("form", {
              id: "kt_account_deactivate_form",
              class: "form",
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.deactivateAccount()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("span", _hoisted_78, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                  ]),
                  _hoisted_79
                ]),
                _hoisted_80
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("button", _hoisted_82, _hoisted_85, 512)
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}